<template>
  <div class="footer">
   
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {

    }
  }
};
</script>

<style scoped>
   .footer{
       position: relative;
       bottom:0;
       left:0;
       width: 100%;
       height: 80px;
       background-color: #e8e7e7;
   }
</style>